import { createContext, useContext, useEffect, useState } from 'react'

const ColorModeContext = createContext()

export function ColorModeProvider({ children }) {
  const [colorMode, setColorModeState] = useState(() => {
    const stored = localStorage.getItem('chakra-ui-color-mode')
    return stored || 'light'
  })

  useEffect(() => {
    const root = document.documentElement
    root.classList.remove('light', 'dark')
    root.classList.add(colorMode)
    localStorage.setItem('chakra-ui-color-mode', colorMode)
  }, [colorMode])

  const toggleColorMode = () => {
    setColorModeState((prev) => (prev === 'light' ? 'dark' : 'light'))
  }

  const setColorMode = (mode) => {
    setColorModeState(mode)
  }

  const value = { colorMode, toggleColorMode, setColorMode }

  // React 19: direct context value without .Provider
  return (
    <ColorModeContext value={value}>
      {children}
    </ColorModeContext>
  )
}

export function useColorMode() {
  const context = useContext(ColorModeContext)
  if (!context) {
    throw new Error('useColorMode must be used within ColorModeProvider')
  }
  return context
}

export function useColorModeValue(lightValue, darkValue) {
  const { colorMode } = useColorMode()
  return colorMode === 'light' ? lightValue : darkValue
}
